import FeaturesPlateNew from './FeaturesPlateNew'

export default FeaturesPlateNew
